export default [
  {
    path: '/visitas-domiciliares',
    component: () => import('@/pages/VisitasDomiciliares/Index.vue'),
  },
  {
    path: '/familias-visitadas',
    component: () =>
      import('@/pages/VisitasDomiciliares/FamiliasVisitadas/Template.vue'),
    children: [
      {
        path: '/familias-visitadas',
        component: () =>
          import('@/pages/VisitasDomiciliares/FamiliasVisitadas/Index.vue'),
      },
    ],
  },
  {
    path: '/cidadaos-visitados',
    component: () =>
      import('@/pages/VisitasDomiciliares/CidadaosVisitados/Template.vue'),
    children: [
      {
        path: '/cidadaos-visitados',
        component: () =>
          import('@/pages/VisitasDomiciliares/CidadaosVisitados/Index.vue'),
      },
    ],
  },
  {
    path: '/visitas-no-mes',
    component: () =>
      import('@/pages/VisitasDomiciliares/VisitasNoMes/Index.vue'),
  },
  {
    path: '/desempenho-por-microarea',
    component: () =>
      import('@/pages/VisitasDomiciliares/DesempenhoPorMicroArea/Template.vue'),
    children: [
      {
        path: '/desempenho-por-microarea',
        component: () =>
          import(
            '@/pages/VisitasDomiciliares/DesempenhoPorMicroArea/Index.vue'
          ),
      },
    ],
  },
]
